/**
 * Builds the `source` for vue-pdf-embed. The bundled pdf.js compiles Type1
 * font glyph programs with `new Function` while `isEvalSupported` is on, so a
 * crafted resume PDF can run script on this origin. Resumes are
 * user-supplied, so every document load must go through this helper.
 */
export const pdfSource = (url: string): { url: string; isEvalSupported: false } => ({
  url,
  isEvalSupported: false,
});
